import type { SVGAttributes } from 'react';

export function UploadFileIcon(props: SVGAttributes<SVGSVGElement>) {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" {...props} viewBox="0 0 16 16">
			<path
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				d="M10.96 5.933c2.4.207 3.38 1.44 3.38 4.14v.087c0 2.98-1.193 4.173-4.173 4.173h-4.34c-2.98 0-4.174-1.193-4.174-4.173v-.087c0-2.68.967-3.913 3.327-4.133M8 10V2.413M10.233 3.9 8 1.667 5.767 3.9"
			/>
		</svg>
	);
}
